import styled from 'styled-components';

export const MobilePdpImage = styled.img`
  width: ${props => props.width};
  height: ${props => props.height};
`;

export const MobilePdpPlayIconContainer = styled.div`
  position: absolute;
  display: flex;
  width: auto;
  height: -webkit-fill-available;
  align-items: center;
  justify-content: center;
`;
